import React, { createContext, useContext, useState, useCallback } from 'react';

const ConsultationModalContext = createContext();

export const useConsultationModal = () => useContext(ConsultationModalContext);

export const ConsultationModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [source, setSource] = useState('');

  const openModal = useCallback((src = '') => {
    setSource(src);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <ConsultationModalContext.Provider value={{ isOpen, source, openModal, closeModal }}>
      {children}
    </ConsultationModalContext.Provider>
  );
};

export default ConsultationModalContext;
